import React, { useRef } from 'react';
import styled from 'styled-components';
import {
	AnimationContainer,
	AnimationImageAsset,
	AnimationImageElement,
	AnimationPositionElement,
} from '../AnimationCommon';
import Functions from '@client/style/Functions';
import { AnimationElementTreetop } from '../AnimationElementTreetop';
import MobileWaveSvg from '@client/assets/svgs/animations/mobile-wave.svg';
import MobileBumpSvg from '@client/assets/svgs/animations/mobile-bump.svg';
import { useSurroundingColors } from '@client/modules/shared/UseSurroundingColors';

const StyledAnimationContainer = styled(AnimationContainer)`
	/* position: relative;
	height: 700px;
	*/
	/* align-self: center;
	justify-self: center;
	width: 100%; */
	/* width: 100%; */
	img {
		max-width: 100%;
		height: auto;
	}
`;

const MobileSpan = styled.span`
	display: block;
	${Functions.breakpoint('mobile')} {
		display: none;
	}
`;
const DesktopSpan = styled.span`
	display: none;
	${Functions.breakpoint('mobile')} {
		display: block;
	}
`;

const WaveContainer = styled.div<{ fill?: string }>`
	width: 100vw;
	svg {
		width: 100%;
		height: auto;
	}
	.filler {
		fill: ${props => props.fill || ''};
	}
`;
const BumpContainer = styled.div<{ fill?: string }>`
	width: 80vw;
	svg {
		width: 100%;
		height: auto;
		fill: ${props => props.fill || ''};
	}
	.filler {
		fill: ${props => props.fill || ''};
	}
`;

const ColorWrapper = styled.div`
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: -1;
	position: absolute;
`;

const TopColor = styled.div<{ bgColor?: string }>`
	top: 0;
	left: 0;
	width: 100%;
	height: 60%;
	z-index: -1;
	background-color: ${props => props.bgColor || ''};
	position: absolute;
`;

const BottomColor = styled.div<{ bgColor?: string }>`
	bottom: 0;
	left: 0;
	width: 100%;
	height: 40%;
	z-index: -1;
	background-color: ${props => props.bgColor || ''};
	position: absolute;
`;

const Walter = () => {
	const image = new AnimationImageAsset('https://www.datocms-assets.com/80292/1686663578-waltergraver.png', {
		tiny: 500,
		mobile: 2000,
	});

	return <AnimationImageElement image={image} />;
};

export function IllustrationWalterGraver() {
	const moduleRef = useRef<HTMLDivElement | null>(null);
	const backgroundColors = useSurroundingColors(moduleRef);

	return (
		<StyledAnimationContainer
			height={1000}
			width={900}
			ref={moduleRef}
			breakpoints={{ mobile: { height: 1100, width: 2600 }, ultra: { width: 4000, height: 1692 } }}
		>
			<DesktopSpan>
				<AnimationElementTreetop
					variant={3}
					position={{
						x: '12%',
						y: '5%',

						scale: 0.4,
						anchor: 'right',
					}}
				></AnimationElementTreetop>
				<AnimationElementTreetop
					variant={4}
					position={{
						x: '-9%',
						y: '12%',
						flip: true,
						scale: 0.25,
						anchor: 'right',
					}}
				></AnimationElementTreetop>
			</DesktopSpan>
			<AnimationElementTreetop
				variant={2}
				position={{ x: '62%', y: '55%', flip: true, scale: 0.4 }}
			></AnimationElementTreetop>

			<AnimationPositionElement
				position={{ anchor: 'right', y: '72%', breakpoints: { mobile: { y: '26%' }, ultra: { y: '20%' } } }}
			>
				<BumpContainer fill={backgroundColors[1]}>
					<MobileSpan>
						<MobileBumpSvg />
					</MobileSpan>
					<DesktopSpan>
						<MobileBumpSvg />
					</DesktopSpan>
				</BumpContainer>
			</AnimationPositionElement>
			<ColorWrapper>
				<TopColor bgColor={backgroundColors[0]}></TopColor>
				<BottomColor bgColor={backgroundColors[1]}></BottomColor>
			</ColorWrapper>

			{/* Trees */}
			<DesktopSpan>
				<AnimationElementTreetop
					variant={4}
					position={{
						x: '14%',
						y: '-4%',
						scale: 0.35,
					}}
				></AnimationElementTreetop>
			</DesktopSpan>
			<AnimationElementTreetop variant={2} position={{ x: '-34%', y: '40%', scale: 0.5 }}></AnimationElementTreetop>
			<AnimationElementTreetop
				variant={3}
				position={{
					x: '5%',
					y: '53%',
					flip: true,
					scale: 0.5,
					breakpoints: { mobile: { x: '41%', y: '-2%', scale: 0.4 } },
				}}
			></AnimationElementTreetop>
			<AnimationElementTreetop
				variant={3}
				position={{ x: '67%', y: '68%', scale: 0.5, breakpoints: { mobile: { x: '46.5%', y: '18%', scale: 0.4 } } }}
			></AnimationElementTreetop>

			<AnimationElementTreetop
				variant={3}
				position={{
					x: '39%',
					y: '89%',
					flip: true,
					scale: 0.7,
					breakpoints: { mobile: { x: '78%', y: '26%', scale: 0.4 } },
				}}
			></AnimationElementTreetop>
			<DesktopSpan>
				<AnimationElementTreetop
					variant={3}
					position={{
						x: '49.5%',
						y: '10%',
						flip: true,
						scale: 0.45,
						anchor: 'right',
					}}
				></AnimationElementTreetop>
				<AnimationElementTreetop
					variant={4}
					position={{
						x: '31%',
						y: '30%',
						anchor: 'right',
						scale: 0.45,
					}}
				></AnimationElementTreetop>
			</DesktopSpan>
			{/* Trees end */}

			<AnimationPositionElement position={{ y: '60%', breakpoints: { mobile: { y: '13%' } } }}>
				<WaveContainer fill={backgroundColors[1]}>
					<MobileSpan>
						<MobileWaveSvg />
					</MobileSpan>
					<DesktopSpan>
						<MobileWaveSvg />
					</DesktopSpan>
				</WaveContainer>
			</AnimationPositionElement>
			<AnimationPositionElement
				position={{
					width: '89%',
					anchor: 'center',
					x: '-50%',
					y: '56%',
					breakpoints: { mobile: { width: '40%', y: '21%' } },
				}}
			>
				<Walter />
			</AnimationPositionElement>
		</StyledAnimationContainer>
	);
}
